<div class="DTX_HEADER_NAV {{ styleClass }}" #navContainer (window:resize)="onResize()">
    <!-- <p-menubar [model]="displayItems" [autoDisplay]="true"></p-menubar> -->
    @for (item of displayItems; track $index) {
        <app-header-nav-item [itemWidth]="itemWidth" [item]="item" [itemGap]="itemGap"></app-header-nav-item>
    }    
    @if(showLogonButton){
        <app-header-nav-item [itemWidth]="itemWidth" [itemGap]="itemGap" [showLogonButton]="true"></app-header-nav-item>
    }
</div>